import { t } from "@/i18n-js/instance";
import type { ButtonProps } from "@/react/components/SettingsApp/CompassCompat/Button";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

export interface ActionsProps {
  handleChangeCoverClick?: ButtonProps["onClick"];
  handleDelete?: ButtonProps["onClick"];
  isProcessing?: boolean;
  value?: string;
}

export const Actions = ({
  value,
  isProcessing = false,
  handleDelete,
  handleChangeCoverClick,
}: ActionsProps) => {
  const hasValue = Boolean(value);

  return (
    <div className="grid grid-flow-col auto-cols-fr gap-2">
      {hasValue && (
        <Button variant="danger" full onClick={handleDelete}>
          {t("remove")}
        </Button>
      )}
      <Button
        full
        variant="secondary"
        onClick={handleChangeCoverClick}
        disabled={isProcessing}
      >
        {hasValue ? t("replace") : t("upload")}
      </Button>
    </div>
  );
};
